import React from "react";
import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/membershipLengthSagas";

const ModuleLogicSwitcher = () => {
  const dispatch = useDispatch();
  const options = useSelector((state) => state.membershipLengthByAgreement.moduleLogicOptions);
  const selectedLogic = useSelector(
    (state) => state.membershipLengthByAgreement?.selectedModuleLogic
  );

  if (Object.keys(selectedLogic).length === 0 || !selectedLogic) {
    return null;
  }

  return (
    <MultiSelectDropdown
      placeholder="Select Metric"
      numberDisplayed={0}
      options={options}
      selectedFilters={selectedLogic}
      multiple={false}
      includeFilter={false}
      onSelectChange={(data) => {
        if (data.id === selectedLogic.id) return;
        dispatch(actionCreators.changeModuleLogic(data));
      }}
    />
  );
};

export default ModuleLogicSwitcher;
